import { render, staticRenderFns } from "./gatewaySwitching.vue?vue&type=template&id=02b8ae4f&scoped=true&"
import script from "./gatewaySwitching.vue?vue&type=script&lang=js&"
export * from "./gatewaySwitching.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02b8ae4f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('02b8ae4f')) {
      api.createRecord('02b8ae4f', component.options)
    } else {
      api.reload('02b8ae4f', component.options)
    }
    module.hot.accept("./gatewaySwitching.vue?vue&type=template&id=02b8ae4f&scoped=true&", function () {
      api.rerender('02b8ae4f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gateway/gatewaySwitching.vue"
export default component.exports